import {createAsyncThunk} from "@reduxjs/toolkit";
import {
    createUser as createUsersApi,
    deleteUser as deleteUserApi,
    exportUsers as exportUsersApi,
    getUsers as getUserApi,
    updateUser as updateUserApi
} from "./api";
import {toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export const getUser = createAsyncThunk("users/getUser", async (filters: any) => {
    try {
        return await getUserApi(filters);
    } catch (error) {
        // Para consistencia, podríamos manejar el error aquí también
        throw error;
    }
})

export const addUser = createAsyncThunk("users/addUser", async (user: any, { rejectWithValue }) => {
    try {
        const response = await createUsersApi(user);
        toast.success("Usuario creado con éxito", {autoClose: 3000});
        return response;
    } catch (error: any) {
        const message = error?.response?.data?.message || "Ocurrió un error al crear el usuario";
        toast.error(message, {autoClose: 3000});
        return rejectWithValue(message);
    }
});

export const updateUser = createAsyncThunk("users/update", async (user: any, { rejectWithValue }) => {
    try {
        const response = await updateUserApi(user);
        toast.success("El usuario se actualizó correctamente", {autoClose: 3000});
        return response;
    } catch (error: any) {
        const message = error?.response?.data?.message || "Ocurrió un error al actualizar el usuario";
        toast.error(message, {autoClose: 3000});
        return rejectWithValue(message);
    }
});

export const deleteUser = createAsyncThunk("users/deleteUser", async (id: any, { rejectWithValue }) => {
    try {
        const response = await deleteUserApi(id);
        toast.success("El usuario ha sido eliminado con éxito", {autoClose: 2000});
        return {id, ...response};
    } catch (error: any) {
        const message = error?.response?.data?.message || "Ocurrió un error al eliminar el usuario";
        toast.error(message, {autoClose: 2000});
        return rejectWithValue(message);
    }
});

export const exportUsers = createAsyncThunk(
    "users/exportUsers",
    async (filters: any,{ rejectWithValue }) => {
        try {
            const response: any = await exportUsersApi(filters);
            const url = window.URL.createObjectURL(response);
            const a = document.createElement("a");
            a.href = url;
            a.download = "usuarios.xlsx";
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            return;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
